/* eslint-disable react/jsx-curly-brace-presence */
import React, { Component, Fragment } from 'react';
import {
  Card, Row, Col, Button, CardTitle,
} from 'reactstrap';
import ReactToPrint from 'react-to-print';
import { GetCurrentFormattedDate, getAge } from './FormatDate';

const ComponentToPrint = ({ treatmentData, petData, clientData }) => (
  <Card>
    <CardTitle>
      <Row className="mt-3">
        <Col xs={{ size: 10, offset: 1 }}>
          <div className="d-flex justify-content-center" style={{ color: '#012e73' }}>
            <u>
              <h1>
                VET CARE
              </h1>
            </u>
          </div>
          <h4 className="d-flex justify-content-center">
            PET CLINIC
          </h4>
        </Col>
      </Row>
      <Row>
        <Col xs={{ size: 10, offset: 1 }}>
          <div className="d-flex">
            <div className="p-2 my-flex-item mr-auto">
              <div style={{ color: '#012e73' }}>
                Dr. H. G. Apte
              </div>
              B.V.Sc., M.Sc.,
              <br />
              Reg. No. 34
            </div>
            <div className="p-2 my-flex-item ">
              <div style={{ color: '#012e73' }}>
                Dr. A. H. Apte
              </div>
              B.V.Sc. & A.H.,
              <br />
              Reg. No. 6181
            </div>
          </div>
        </Col>
      </Row>
    </CardTitle>
    <Row>
      <Col xs={{ size: 10, offset: 1 }}>
        <div className="d-flex justify-content-center" style={{ borderTop: '1px solid black', borderBottom: '1px solid black' }}>
          Time: 10:00a.m. to 12.00 p.m & 6.00 p.m to 8:00 p.m, Sunday Closed
        </div>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col xs={{ size: 10, offset: 1 }}>
        <h4 className="d-flex justify-content-center font-weight-bold" style={{ color: '#012e73' }}>
          <u>VACCINATION CERTIFICATE</u>
        </h4>
        <div className="d-flex justify-content-center font-weight-bold">
          Note: Please preserve carefully
        </div>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col xs={{ size: 10, offset: 1 }}>
        <div>
          {petData.type.label === 'Canine' ? (
            <>
              Dog
            </>
          ) : (
            <>
              Cat
            </>
          )}
          {'  '}
          Belonging to
          {'  '}
          <u>{clientData.name}</u>
        </div>
        <div>
          Address :
          {'  '}
          <u>{clientData.address}</u>
        </div>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col xs={{ size: 10, offset: 1 }}>
        <h5>Vaccinated Against:</h5>
        {'  '}
        {treatmentData.vaccination.map((row) => (
          <Fragment key={row.value}>
            {row.label === 'DHAPPiL' ? (
              <div>
                <div>- Distemper, Parvovirus, Leptospirosis</div>
                <div>  Adenovirus, Parainfluenza, Hepatitis</div>
              </div>
            ) : (
              <div>
                {row.label === 'Tricat' ? (
                  <div>- Calicivirus, Herpis virus, Panleukopenia</div>
                ) : (
                  <div>
                    {' '}
                    {row.label}
                  </div>
                )}

              </div>
            )}
          </Fragment>
        ))}
      </Col>
    </Row>
    <Row className="mt-3">
      <Col xs={{ size: 10, offset: 1 }} style={{ border: '1px solid black', borderRadius: '10px' }}>
        <Row>
          <Col xs={{ size: 4, offset: 1 }}>
            ON:
            {' '}
            {GetCurrentFormattedDate()}
          </Col>
          <Col xs={{ size: 4, offset: 1 }}>
            Due:
          </Col>
        </Row>
      </Col>
    </Row>
    <Row className="mt-3">
      <Col xs={{ size: 10, offset: 1 }}>
        <h5>Pet Description:</h5>
        <Row>
          <Col xs={{ size: 4, offset: 1 }}>
            Name:
            {'  '}
            <u>{petData.name}</u>
          </Col>
          <Col xs={{ size: 4, offset: 1 }}>
            Breed:
            {'  '}
            <u>{petData.breed.label}</u>
          </Col>
        </Row>
        <Row>
          <Col xs={{ size: 4, offset: 1 }}>
            Colour:
            {'  '}
            <u>{petData.color.label}</u>
          </Col>
          <Col xs={{ size: 4, offset: 1 }}>
            Age:
            {'  '}
            <u>{getAge(petData.dob.seconds)}</u>
          </Col>
        </Row>
        <Row>
          <Col xs={{ size: 4, offset: 1 }}>
            Sex:
            {'  '}
            <u>{petData.gender}</u>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col xs={{ size: 10, offset: 1 }}>
        <div className="d-flex flex-row-reverse bd-highlight">
          <div className="p-2 bd-highlight">
            <p className="text-right">Dr. A.H. Apte</p>
          </div>
        </div>
      </Col>
    </Row>
    <hr />
    <div className="text-center">Shop No. 7, Dr. Herekar Park Bldg, Near Kamla Nehru park, Pune 411004,</div>
    <div className="text-center">Phone: 20-25679175, Emergency Call: 98500 94099. Email: drapte.vetcare@gmail.com</div>
  </Card>
);

class PrintCertificateComponent extends Component {
  render() {
    const {
      clientData,
      treatmentData,
      petData,
      togglePrintCertificate,
    } = this.props;
    return (
      <div>
        <Row className="mt-3">
          <Col xs={{ size: 4, offset: 1 }}>
            <ReactToPrint
              trigger={() => <Button block color="primary">Print</Button>}
              content={() => this.componentRef}
            />
          </Col>
          <Col xs={{ size: 4, offset: 1 }}>
            <Button color="secondary" className="mb-3" block onClick={() => { togglePrintCertificate({}); }}>Cancel</Button>
          </Col>
        </Row>
        <ComponentToPrint
          className="mt-3"
          clientData={clientData}
          treatmentData={treatmentData}
          petData={petData}
          // eslint-disable-next-line no-return-assign
          ref={(el) => (this.componentRef = el)}
        />
      </div>
    );
  }
}

export default PrintCertificateComponent;
